import React from 'react'
import { LuxIcon, Color } from '@lux/wardrobe-lib'

export default (props: any) => {
    const { active, label, onButtonChange, componentClass } = props

    return (
        <div
            className={`${componentClass} ${active ? 'active' : ''}`}
            onClick={onButtonChange}
            role="button"
            tabIndex={0}>
            {/* <LuxButton variant={`${active ? 'outlined' : ''}`} text={label} onClick={onButtonChange} /> */}
            <span className="flex">{label}</span>
            {active && (
                <>
                    <LuxIcon icon="check" color={Color.WHITE} />{' '}
                    <LuxIcon icon="status-ko" color={Color.WHITE} />
                </>
            )}
        </div>
    )
}
